import { black, green, red, yellow } from 'globals/colors';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core';
import { TeammateStatus } from 'globals/types';

export const getColor = (type: TeammateStatus): string => {
  switch (type) {
    case TeammateStatus.ACTIVE:
      return green.MAIN;
    case TeammateStatus.SUSPENDED:
      return red.MAIN;
    case TeammateStatus.INACTIVE:
      return yellow.MAIN;
    default:
      return black;
  }
};

export const useStyles = makeStyles(({ palette, spacing }: Theme) =>
  createStyles({
    icon: {
      marginRight: spacing(1),
      color: palette.grey[300],
    },
  })
);
